module.exports = "/_next/static/images/Clock@3x-6e2f934c937e496c8272d0761161205c.png";